import { Component, OnInit, Input } from '@angular/core';
import { EventService } from 'app/services/event-service';

@Component({
    selector: 'app-event-pagination',
    templateUrl: './event-pagination.component.html',
    styleUrls: ['./event-pagination.component.scss']
})
export class EventPaginationComponent implements OnInit {

    @Input() loading: Boolean;
    @Input() response: any;

    constructor(private eventService: EventService) { }

    ngOnInit() {
    }

    onChange(value) {
        this.eventService.setPageSize(value);
    }

    start(): String {
        return this.response.pageable.offset + 1;
    }

    end(): String {
        if (!this.response.last) {
            return this.response.pageable.offset + this.response.pageable.pageSize
        } else {
            return this.response.totalElements;
        }
    }

    total(): String {
        return this.response.totalElements;
    }

    prev() {
        if (!this.loading && !this.response.first) {
            this.eventService.setPageOffset(this.response.number - 1);
        }
    }

    next() {
        if (!this.loading && !this.response.last) {
            this.eventService.setPageOffset(this.response.number + 1);
        }
    }

    showPagination(): Boolean {
        return this.response.totalElements > 5;
    }

}

